import React from "react";
import { getAssets } from "@unisearch/helpers";
import Link from "next/link";
import styles from "./counseller_card.module.scss";

const CounsellerCard = (props) => {
  return (
    <div
      className={`${styles.mentor_list_item} ${
        props.border ? styles.border : ""
      }`}
    >
      <div className={styles.mentor_avatar}>
        <Link legacyBehavior href={props.link || "#"}>
          <a>
            <img
              src={props.avatar || getAssets("assets/images/avatar.png")}
              alt="avatar"
            />
          </a>
        </Link>
      </div>
      <Link legacyBehavior href={props.link || "#"}>
        <a>
          <h5 className={styles.mentor_name}>{props?.name || "Name"}</h5>
        </a>
      </Link>
      {/* <p className={styles.mentor_country}>Canada</p>
      <h4 className={styles.mentor_university}>Simon Fraser University</h4> */}
      <div className={styles.mentor_designation}>
        {props.designation || "Counsellor"}, {props.country || "Country"}
      </div>
      <Link legacyBehavior href={props.link || "#"}>
        <a className={`btn btn-secondary ${styles.mentor_btn}`}>View Profile</a>
      </Link>
    </div>
  );
};

export default CounsellerCard;
